<section class="py-6 border-b border-b-shs-gray-4" [formGroup]="eskerDiscrepancyDomesticForm!">
    <h2 class="text-base font-bold text-font-primary">Additional Information</h2>
    <div class="mt-4 flex flex-col gap-4">
        <sag-ui-input
            [required]="true"
            label="Related No-Charge Replacement or Credit/Debit Number"
            placeholder="Enter the credit/debit number (e.g., 3249 2341 3543 12352)"
            formControlName="creditNumber"
            class="max-w-input"
        ></sag-ui-input>
        <sag-ui-input
            [required]="true"
            label="Related Call Tag Tracking Number"
            placeholder="Enter the tracking number (e.g., 732974323)"
            formControlName="callTagTrackingNumber"
            class="max-w-input"
        ></sag-ui-input>
        <app-attachments-input
            [form]="eskerDiscrepancyDomesticForm!"
            controlName="relatedDocuments"
        ></app-attachments-input>
        <sag-ui-textarea
            [required]="true"
            label="Provide any additional information that will aid the Root Cause Investigation"
            placeholder="Provide any relevant details about the issue"
            formControlName="additionalInfo"
            class="max-w-input"
        />
        <sag-ui-radio-group
            label="Would the customer like a financial adjustment (credit)?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="financialAdjustment" formControlName="financialAdjustment" [value]="true"
                >Yes</sag-ui-radio
            >
            <sag-ui-radio name="financialAdjustment" formControlName="financialAdjustment" [value]="false"
                >No</sag-ui-radio
            >
        </sag-ui-radio-group>
        @if (isTrue('financialAdjustment')) {
        <sag-ui-radio-group
            label="Has the COD been filed within 30 days of the ship date?"
            direction="row"
            [required]="true"
        >
            <sag-ui-radio name="filedWithin30Days" formControlName="filedWithin30Days" [value]="true">Yes</sag-ui-radio>
            <sag-ui-radio name="filedWithin30Days" formControlName="filedWithin30Days" [value]="false">No</sag-ui-radio>
        </sag-ui-radio-group>
        @if (isFalse('filedWithin30Days')) {
        <div class="max-w-input">
            <app-manager-select
                [formGroup]="eskerDiscrepancyDomesticForm!"
                controlName="managerApprovedRequest"
            ></app-manager-select>
        </div>
        }
        <sag-ui-input
            [required]="true"
            [step]="0.01"
            label="Value of the financial adjustment in US Dollars:"
            placeholder="Enter the amount in US Dollars"
            formControlName="adjustmentAmount"
            type="number"
            class="max-w-input"
            ><span ngProjectAs="end-decorator" class="text-[#F3F3F0] pr-4 h-full flex items-center justify-center">
                $
            </span></sag-ui-input
        >
        }
        <div class="flex justify-end max-w-input">
            <sag-ui-button [disabled]="!isValid()" (click)="handleConfirm()" size="sm">Confirm</sag-ui-button>
        </div>
    </div>
</section>
